@if (student) {
  <section class="information-container">
    <head class="personal-info-head">
      <h2 class="personal-Info">Personal Information</h2>
      @if (isStudent) {
        <mat-icon (click)="edit()">edit</mat-icon>
      }
    </head>
    <mat-divider class="divider"></mat-divider>
    <section class="personal-info-container">
      @if (shouldDisplayProfileSection()) {
        <section class="profile-image-container" (click)="openUpload()">
          <img
            [src]="profilePhotoUrl"
            alt="Profile Photo"
            class="profile-photo"
            loading="lazy"
          />
          @if (isStudent) {
            <p class="photo-action">
              {{
                student.profilephoto
                  ? "Edit profile photo"
                  : "Add profile photo"
              }}
            </p>
          }
        </section>
      }
      <section
        class="information-container"
        [ngClass]="{ 'text-container': shouldDisplayProfileSection() }"
      >
        <section class="student-info-more">
          <section class="student-info-item">
            <p class="grey-text">Full Name</p>
            <p>{{ student.name }} {{ student.surname }}</p>
          </section>
          <section class="student-info-item">
            <p class="grey-text">Date of Birth</p>
            <p>
              {{
                student.dob
                  ? (student.dob | date: "mediumDate")
                  : (student.dateOfBirth | date: "mediumDate")
              }}
            </p>
          </section>
          <section class="student-info-item">
            <p class="grey-text">Contact Number</p>
            <p>{{ student.contactNumber || "_" }}</p>
          </section>
          <section class="student-info-item">
            <p class="grey-text">Email</p>
            <p>{{ student.email }}</p>
          </section>
        </section>
        <section class="student-info-more row2">
          <section class="student-info-item">
            <p class="grey-text">Address</p>
            <p>{{ student.address }}</p>
          </section>
          <section class="student-info-item">
            <p class="grey-text">Suburb/District</p>
            <p>{{ student.suburb }}</p>
          </section>
          <section class="student-info-item">
            <p class="grey-text">City/Town</p>
            <p>{{ student.city }}</p>
          </section>
          <section class="student-info-item">
            <p class="grey-text">Postal Code</p>
            <p>{{ student.code }}</p>
          </section>
        </section>
      </section>
    </section>
  </section>
}
